module.exports = __webpack_public_path__ + "img/product_133.45e4661.webp";